import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, IconButton, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { BasketItem } from '../../interfaces/Basket/BasketItem';
import { getUserBasket } from '../../api/Basket';
import { sharedStyles } from '../../utils/Style';
import { BasketItemsTable } from './BasketItemsTable';
import { Waiting } from '../../components/Waiting/Waiting';

export const BasketItemsPage = () => {
  const navigate = useNavigate();

  const { userID: userIDAsStr } = useParams<string>();

  const userID = userIDAsStr ? Number(userIDAsStr) : undefined;

  const [items, setItems] = useState<BasketItem[]>([]);
  const [loading, setLoading] = useState(false);

  const refreshItems = () => {
    if (!Number.isFinite(userID)) {
      return;
    }

    setLoading(true);
    getUserBasket(userID!)
      .then((i) => setItems(i))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshItems();
  }, [userID]);

  const goBack = () => navigate('/sales/baskets');

  return (
    <Box sx={{ ...sharedStyles.pageBody }}>
      <Waiting open={loading} />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          flexWrap: 'wrap',
          mb: 3,
          gap: 1.5,
        }}
      >
        <IconButton onClick={goBack} sx={{ ...sharedStyles.backIcon }}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant='h5'>Kullanıcı Sepeti</Typography>
      </Box>

      <BasketItemsTable basketItems={items} onDelete={refreshItems} />
    </Box>
  );
};
